// extracted by mini-css-extract-plugin
export var colorSquare = "_r1-0";
export var danger = "_r1-5";
export var lightPink = "_r1-8";
export var neutralBlue = "_r1-7";
export var neutralYellow = "_r1-6";
export var normal = "_r1-1";
export var primary = "_r1-2";
export var primaryLight = "_r1-3";
export var solidBlack = "_r1-g";
export var solidGreen = "_r1-b";
export var solidLightBlue = "_r1-d";
export var solidNavy = "_r1-c";
export var solidOrange = "_r1-f";
export var solidPink = "_r1-e";
export var solidRed = "_r1-9";
export var solidYellow = "_r1-a";
export var success = "_r1-4";